// extracted by mini-css-extract-plugin
module.exports = {"skiptomainlink":"SkipToMain_skiptomainlink__uIRP8"};